import propTypes from 'prop-types';
import React from 'react';
import { FormattedNumber } from 'react-intl';

export const Number = ({ value }) => <FormattedNumber value={value} />;

Number.propTypes = {
  value: propTypes.number,
};
